import { inject } from '@angular/core';
import { EmployeeApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { EMPLOYEE_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const taFormConfig = (): FormConfig => {
  const employeeApiService = inject(EmployeeApiService);
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'employeeId', label: 'Nhân viên', required: true, width: 'full',
        type: 'select', config: { ...EMPLOYEE_SELECT_CONFIG, service: employeeApiService },
        disabled: (editMode) => editMode
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};
